<div id="flex-component">
    <mizvid-videoShow [shenase]="shenase" *ngIf="videoShowComponent_isShowing" (close_req)="videoShowComponent_isShowing = false" (videoInit)="saveActiavatedShenase($event)"></mizvid-videoShow>
    <div id="payeha-container">
        <mat-accordion *ngFor="let PayeNum_en of videos_json.listePayeha; index as index_paye;">
            <mat-expansion-panel [expanded]="wouldThisPayeBeOpen(PayeNum_en)">
                <mat-expansion-panel-header>
                    <mat-panel-title style="font-weight: bolder;">
                        {{videos_json['payeye'+PayeNum_en].shomareyeTartibiyePaye}}
                    </mat-panel-title>
                    <mat-panel-description>
                        فیلم‌های {{videos_json['payeye'+PayeNum_en].shomareyeTartibiyePaye}} در کلاس {{respectfulName}}
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <!-- فصل‌ها -->
                    <div *ngFor="let index_fasl of numToArray(videos_json['payeye'+PayeNum_en].tedadeFaslha)">
                        <mat-accordion>
                            <mat-expansion-panel [expanded]="wouldThisFaslBeOpen(PayeNum_en, index_fasl)">
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        فصل {{numToFa(index_fasl)}}: {{videos_json['payeye'+PayeNum_en]['fasle'+index_fasl].onvaneFasl}}
                                    </mat-panel-title>
                                    <mat-panel-description>
                                        <!-- مثلا حالا یه توضیح کوتاه -->
                                    </mat-panel-description>
                                </mat-expansion-panel-header>
                                <ng-template matExpansionPanelContent>
                                    <!-- درس‌ها -->
                                    <div *ngFor="let index_dars of numToArray(count_tedadeDars(PayeNum_en, index_fasl))">
                                        <mat-accordion>
                                            <mat-expansion-panel #dars (click)="scroll(dars)" [expanded]="wouldThisDarsBeOpen(PayeNum_en, index_fasl, index_dars)">
                                                <mat-expansion-panel-header>
                                                    <mat-panel-title>
                                                        درس {{numToFa(index_dars)}}: {{videos_json['payeye'+PayeNum_en]['fasle'+index_fasl]['darse'+index_dars].onvaneDars}}
                                                    </mat-panel-title>
                                                    <mat-panel-description>
                                                        <!-- مثلا حالا یه توضیح کوتاه -->
                                                    </mat-panel-description>
                                                </mat-expansion-panel-header>
                                                <ng-template class="ghesmatha" matExpansionPanelContent>
                                                    <ul>
                                                        <!-- قسمت‌ها -->
                                                        <li *ngFor="let index_ghesmat of numToArray(count_tedadeGhesmat(PayeNum_en, index_fasl, index_dars))">
                                                            <div (click)="show_videoShowComponent(videos_json['payeye'+PayeNum_en]['fasle'+index_fasl]['darse'+index_dars]['ghesmate'+index_ghesmat].shenase)">
                                                                <span class="ghesmat_sign">
                                                                  <!--قسمت-->
                                                                  قطعه‌فیلم {{numToFa(index_ghesmat)}}:
                                                                </span>
                                                                <!-- &nbsp; -->
                                                                <br>
                                                                <div class="ghesmat_title">
                                                                    <span class="inner-animatable_ghesmat" attr.data-after="{{videos_json['payeye'+PayeNum_en]['fasle'+index_fasl]['darse'+index_dars]['ghesmate'+index_ghesmat].onvan}}">
                                                                    <span [ngClass]="{'activated-ghesmat': videos_json['payeye'+PayeNum_en]['fasle'+index_fasl]['darse'+index_dars]['ghesmate'+index_ghesmat].shenase == activatedShenase && videoShowComponent_isShowing}"  style="position: absolute;">
                                                                      {{videos_json['payeye'+PayeNum_en]['fasle'+index_fasl]['darse'+index_dars]['ghesmate'+index_ghesmat].onvan}}
                                                                    </span>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </li>
                                                        <!--  -->
                                                    </ul>
                                                </ng-template>
                                                <!-- <mat-action-row><button mat-button>Click me</button></mat-action-row> -->
                                            </mat-expansion-panel>
                                        </mat-accordion>
                                    </div>
                                    <!--  -->
                                </ng-template>
                                <!-- <mat-action-row>
                              <button mat-button>Click me</button>
                          </mat-action-row> -->
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>
                    <!--  -->
                </ng-template>
                <!-- <mat-action-row>
              <button mat-button>Click me</button>
          </mat-action-row> -->
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>
